module.exports = __webpack_public_path__ + "media/images/mermaid-green-0384efb41d2674a4a07e05e68e611af4.png";